import { render } from "./QuizLoadingView.vue?vue&type=template&id=1dcf08ba&ts=true"
import script from "./QuizLoadingView.vue?vue&type=script&lang=ts"
export * from "./QuizLoadingView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__